module.exports = {
  anchorLinkWatercolorBg:
    'url(https://images.ctfassets.net/0sea1vycfyqy/1QbuFWY78nmXQPYvFDNQXG/3b63382b1238ea0a569083b19529844b/light-blue-watercolor-bg.png?h=250)',
  videoBackgroundLeft:
    'url(https://images.ctfassets.net/0sea1vycfyqy/7hiKwYtTxV5Wydk3IoOHFQ/d6844ce405dc536d206bd1564ab258bd/brush_stroke_red_mobile_cropped.webp)',
  videoBackgroundRight:
    'url(https://images.ctfassets.net/0sea1vycfyqy/4dUdJBz3UsUMWpfQroYBxQ/78d78fddf545527e7c23c64109289f22/brush_stroke_blue_mobile_cropped.webp)',
  videoBackgroundLeftMd:
    'url(https://images.ctfassets.net/0sea1vycfyqy/3v2ebWAdgRbSFHbBkXz13z/281929607bec816d5c9d1b06de331a25/brush_stroke_red.webp)',
  videoBackgroundRightMd:
    'url(https://images.ctfassets.net/0sea1vycfyqy/4nd4B9ifj1hprSZR3E6kQl/558b618cc33d2c266242fce2ffc784d8/brush_stroke_blue.webp)',
  checks:
    'url(https://images.ctfassets.net/0sea1vycfyqy/4brSMyAshf9CLOT7lbEhvC/c75ef0458cfbfe3ef9beea2bd5648078/checkmark-icon-green.png)',
};
